import { render } from "./TrashCanOutline.vue?vue&type=template&id=72aa3c44"
import script from "./TrashCanOutline.vue?vue&type=script&lang=js"
export * from "./TrashCanOutline.vue?vue&type=script&lang=js"

import exportComponent from "../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"@apostrophecms/vue-material-design-icons/TrashCanOutline.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "72aa3c44"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('72aa3c44', __exports__)) {
    api.reload('72aa3c44', __exports__)
  }
  
  module.hot.accept("./TrashCanOutline.vue?vue&type=template&id=72aa3c44", () => {
    api.rerender('72aa3c44', render)
  })

}


export default __exports__